export default function BrandLogo(): JSX.Element {
  return (
    <div className="brand" aria-label="AfriHR">
      <span className="brand-mark" aria-hidden="true">
        <svg width="22" height="22" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 3.5l11.5 6.6v11.8L16 28.5 4.5 21.9V10.1L16 3.5z" stroke="#ffffff" strokeOpacity="0.55" strokeWidth="1.2" fill="none" />
          <path d="M10.5 22.5L15.2 9.5h1.7l4.7 13H19.4l-1.1-3.2h-4.7L12.5 22.5H10.5zm4-5h3.1L16 12.8l-1.5 4.7z" fill="#ffffff" />
          <circle cx="23.6" cy="22.3" r="1.6" fill="#f2a341" />
        </svg>
      </span>
      <span className="brand-wordmark">
        <span className="wm-name">AfriHR</span>
        <span className="wm-tag">People &middot; Payroll &middot; Compliance</span>
      </span>
    </div>
  );
}
